import ReactDOM from 'react-dom/client';
import './global.css';
// Component/layout half of the Speed skin — must load after global.css.
import './speed-ui.css';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { WalletProvider } from './features/wallet';

const root = ReactDOM.createRoot(document.getElementById('root')!);

// The static fallback in index.html is only there for the case where we never
// get this far. Once React owns #root it must go, or it would sit behind the app.
document.getElementById('boot-fallback')?.remove();

// MSW mocking disabled - testing real API endpoint
// To re-enable, uncomment the block below and comment out the direct render
// ErrorBoundary OUTSIDE WalletProvider, deliberately.
//
// It used to be inside App, which meant anything WalletProvider threw during
// mount escaped every boundary and left a black screen — the failure mode users
// hit in in-app browsers, where wallet init is least likely to work. A boundary
// only catches what renders BELOW it, so the provider most likely to fail has to
// sit below the boundary rather than above it.
root.render(
    <ErrorBoundary>
        <WalletProvider>
            <App />
        </WalletProvider>
    </ErrorBoundary>,
);

// Setup MSW mock server in both development and production
// Certify MSW's Service Worker is available before starting React app
// import('../mocks/browser')
//     .then(async ({ worker }) => {
//         return worker.start();
//     }) // Run <App /> when Service Worker is ready to intercept requests
//     .then(() => {
//         root.render(<App />);
//     });
